.redux-container-spacing select,
.redux-container-spacing .select_wrapper {
	width: 80px !important;
	float: left;
}
.redux-container-spacing .field-spacing-input {
	margin-right: 10px;
	margin-bottom: 7px;
}

@media screen and (max-width: 782px) {
	.redux-container-spacing .field-spacing-input input {
		display: inline-block !important;
		width: 70px !important;
	}
	.redux-container-spacing .field-spacing-input .add-on {
		padding: 7px 4px;
		font-size: 16px;
		line-height: 1.5;
	}
	.redux-container-spacing .select_wrapper {
		margin-top: 6px;
	}
}
/*# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlZHV4LXNwYWNpbmcuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDSTtBQUFBO0NBRUk7Q0FDQTs7QUFHSjtDQUNJO0NBQ0E7OztBQUlSO0NBR1k7RUFDSTtFQUNBOztDQUdKO0VBQ0k7RUFDQTtFQUNBOztDQUlSO0VBQ0kiLCJmaWxlIjoicmVkdXgtc3BhY2luZy5jc3MifQ== */

/*# sourceMappingURL=redux-spacing.css.map */
